"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = exports.DEFAULT_HOURS_BACK = void 0;
const zod_1 = require("zod");
// Default window: 30 days. The server anchors "now" and derives the window from it, so a rolling
// window can't drift with client clock skew — the client asks for a length, not a range.
exports.DEFAULT_HOURS_BACK = 720;
exports.requestSchema = zod_1.z.object({
    lngLats: zod_1.z.array(zod_1.z.string()),
    hoursBack: zod_1.z.number().int().positive().max(8760).optional(),
});
exports.responseSchema = zod_1.z.object({
    probes: zod_1.z.array(zod_1.z.object({
        lngLat: zod_1.z.string(),
        // Hours in the window with at least one reading, at any depth.
        reportedHours: zod_1.z.number(),
        // Hours elapsed in the window — the denominator, returned so callers can render "612 / 720 hrs"
        // without re-deriving it (and without depending on their own clock).
        expectedHours: zod_1.z.number(),
        uptimePercent: zod_1.z.number(),
    })),
});
exports.path = '/soil/probe-uptime';
//# sourceMappingURL=index.js.map